// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useEffect, useState } from 'react';
import moment from 'moment';
import Platform from '../../../components/common/Platform';
import LoadingIcon from '../../../components/LoadingIcon';
import { S } from '../styles';
import { HandsOnCompletionStatusType } from '../../../types/Model';
import { FormattedMessage } from 'react-intl';
import { getHistory } from '../../../apis/member';
import { Link } from 'react-router-dom';

export interface HistoryRow {
  name: string;
  platformId: number;
  status: HandsOnCompletionStatusType;
  sendTime: Date | null;
  reviewTime: Date | null;
  id: number;
}
interface HistoryTableProps extends Omit<ComponentPropsWithRef<'div'>, 'id'> {
  list: HistoryRow[];
}

const ReviewHistoryTable = (props: any): JSX.Element => {
  const [sortKey, setSortKey] = useState('');
  const [isAscending, setIsAscending] = useState(false);
  const [historyList, setHistoryList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  const Headers = {
    name: 'B058',
    reviewee: 'B056',
    platformId: 'B023',
    sendTime: 'B026',
    status: 'B025',
    reviewTime: 'B057',
    id: 'B038',
  }

  const handleSorting = (key: string) => {
    if (key !== 'id') {
      setSortKey(key);
      if (key === sortKey) {
        setIsAscending(!isAscending);
      } else {
        setIsAscending(true);
      }
      if (isAscending) {
        historyList.sort((a: any, b: any) => {
          return a[key].toString().localeCompare(b[key].toString())
        })
      } else {
        historyList.sort((a: any, b: any) => {
          return b[key].toString().localeCompare(a[key].toString())
        })
      }
    }
  }

  const getHistoryData = async () => {
    const result = await getHistory('examReview');
    const data = result.data;
    data.forEach((item: any) => {
      if (item.isSubmit) {
        item.status = 'Reviewed';
      } else {
        item.status = 'NoReview';
      }
    })
    setHistoryList(data);
    setIsLoading(false);
  }

  useEffect(() => {
    setIsLoading(true);
    getHistoryData()
  }, [])

  const renderLoading = () => {
    return (
      <S.LoadingContainer>
        <LoadingIcon size={20} />
      </S.LoadingContainer>
    )
  }

  return (
    <>
      { isLoading ? renderLoading()
        : (
          <>
            { historyList.length === 0 ? (
              <S.NoHandsOnHistoryContainer>
                <S.EmptyHomeIcon />
                <S.EmptyHomeText><FormattedMessage id="B051" /></S.EmptyHomeText>
                <S.EmptyHomeLink as={Link} to={'/exams'}><FormattedMessage id="B052" /></S.EmptyHomeLink>
              </S.NoHandsOnHistoryContainer>
            ) : (
              <S.ReviewHistoryTableWrapper>
                {
                  (Object.keys(Headers) as Array<keyof HistoryRow>).map((key: keyof HistoryRow, index) => (
                    <S.HistoryTableHeading
                      key={index}
                      onClick={() => handleSorting(key)}
                      isCenter={[1, 2, 3, 4, 5, 6].indexOf(index) !== -1}
                    >
                      <S.TableHeadingText><FormattedMessage id={Headers[key]} values={{ br: (<br />) }} />{sortKey === key && <S.TableSortIcon isAscending={isAscending} />}</S.TableHeadingText>
                    </S.HistoryTableHeading>
                  ))
                }
                { historyList.map((value: any, index: number) => {
                  return (
                    <React.Fragment key={index}>
                      <S.ReviewHistoryTableCell key={index}><S.ReviewHistoryName>{value.examName}</S.ReviewHistoryName><S.LevelMeter levelId={value.levelId} showName={false} /></S.ReviewHistoryTableCell>
                      <S.ReviewHistoryTableCell isCenter>{value.reviewee}</S.ReviewHistoryTableCell>
                      <S.ReviewHistoryTableCell isCenter><Platform id={value.platformId} /></S.ReviewHistoryTableCell>
                      <S.ReviewHistoryTableCell isCenter>{value.sendTime ? moment(value.sendTime).format('YYYY/MM/DD HH:mm:ss') : '--'}</S.ReviewHistoryTableCell>
                      <S.ReviewHistoryTableCell isCenter><S.HandsOnCompletionStatusTag type={value.status} /></S.ReviewHistoryTableCell>
                      <S.ReviewHistoryTableCell isCenter>{value.reviewTime ? moment(value.reviewTime).format('YYYY/MM/DD HH:mm:ss') : '--'}</S.ReviewHistoryTableCell>
                      <S.ReviewHistoryTableCell isCenter>
                        <S.HistoryTableCellLink href={value.reviewPageUrl} target="_blank">{ value.status === 'NoReview' ? <S.EditIcon/> : <S.VisibleIcon />}</S.HistoryTableCellLink>
                      </S.ReviewHistoryTableCell>
                    </React.Fragment>
                  )
                })}
              </S.ReviewHistoryTableWrapper>
            ) }
          </>
        ) }
    </>
  );
};

export { ReviewHistoryTable as default };
